import React, { useState } from 'react';
import { BsPerson } from 'react-icons/bs';
import { BiSearch } from 'react-icons/bi';
import { AiOutlineClose } from 'react-icons/ai';
import { HiOutlineMenuAlt4 } from 'react-icons/hi';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaPinterest,
  FaYoutube,
} from 'react-icons/fa';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [logo, setLogo] = useState(false)
  const handleNav = () => {
    setNav(!nav);
    setLogo(!logo)
  };

  return (
    <div className='flex w-full justify-between items-center h-20 px-4 absolute z-10 text-white'>
      <div>
        <h1 onClick={handleNav} className={logo ? 'hidden' : 'block' }>WATA.</h1>
      </div>
      <ul className='hidden md:flex'>
        <li className='cursor-pointer'>Home</li>
        <li className='cursor-pointer'>Destinos</li>
        <li className='cursor-pointer'>Viajes</li>
        <li className='cursor-pointer'>Booking</li>
        <li className='cursor-pointer'>Sobre nosotros</li>
      </ul>
      <div className='hidden md:flex cursor-pointer'>
        <BiSearch className='cursor-pointer' size={20} />
        <BsPerson size={20} />
      </div>

      {/* Hamburger */}
      <div onClick={handleNav} className='md:hidden z-10'>
        {nav ? <AiOutlineClose className='text-black' size={20} /> : <HiOutlineMenuAlt4 size={20} />}
      </div>

      {/* Mobile menu dropdown */}
      <div onClick={handleNav} className={nav ? 'absolute text-black left-0 top-0 w-full bg-gray-100/90 px-4 py-7 flex flex-col' : 'absolute left-[-100%]'}>
        <ul>
          <h1>WATA.</h1>
          <li className='border-b'>Home</li>
          <li className='border-b'>Destinos</li>
          <li className='border-b'>Viajes</li>
          <li className='border-b'>Booking</li>
          <li className='border-b'>Sobre nosotros</li>
          <div className='flex flex-col cursor-pointer'>
            <button className='my-6'>Search</button>
            <button>Account</button>
          </div>
          <div className='flex justify-between my-6'>
            <FaFacebook className='icon' />
            <FaTwitter className='icon' />
            <FaYoutube className='icon' />
            <FaPinterest className='icon' />
            <FaInstagram className='icon' />
          </div>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
